import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import { getIsHeaderBannerHidden } from 'src/store/headerBanner/selectors';
import {
  activeHotelSelector,
  hotelInfoFromPopupSelector,
  isExpandedMapSelector,
  mapHotelsListSelector,
  yandexMapPositionSelector,
} from '../../store/map/selectors';

import YandexMapsSearch from './YandexMapsSearch';
import { getMapDataAction } from '../../store/map/sagaActions';
import { resetPopupData, toggleMap } from '../../store/map/slice';

const mapStateToProps = (state) => ({
  activeHotel: activeHotelSelector(state),
  hotelsList: mapHotelsListSelector(state),
  mapPosition: yandexMapPositionSelector(state),
  isMobile: getIsMobile(state),
  isExpanded: isExpandedMapSelector(state),
  hotelInfoForPopup: hotelInfoFromPopupSelector(state),
  isHeaderBannerHidden: getIsHeaderBannerHidden(state),
});

const mapDispatchToProps = {
  getMapDataHandler: getMapDataAction,
  toggleHandler: toggleMap,
  resetPopupDataHandler: resetPopupData,
};

export const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(YandexMapsSearch);
